import { memo, useCallback } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const LOCATION_OPTIONS: { value: string; label: string }[] = [
  { value: "Breadford", label: "Breadford" },
  { value: "Brimingham", label: "Brimingham" },
  { value: "London", label: "Cardiff" },
  { value: "london", label: "London" },
  { value: "Manchester", label: "Manchester" },
  { value: "Leicester", label: "Leicester" },
  { value: "Scheffield", label: "Scheffield" },
  { value: "Glasgo", label: "Glasgo" },
];

function Form() {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      // Form is uncontrolled, no state management needed
    },
    []
  );

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
  }, []);

  return (
    <form
      className="container my-4"
      onSubmit={handleSubmit}
      aria-label={t("events.form.ariaRegistration")}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-firstName">
            {t("events.form.firstNameLabel")}
          </label>
          <input
            id="event-form-firstName"
            type="text"
            name="firstName"
            className="form-control"
            placeholder={t("events.form.firstNamePlaceholder")}
            required
            onChange={handleChange}
            autoComplete="given-name"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-lastName">
            {t("events.form.lastNameLabel")}
          </label>
          <input
            id="event-form-lastName"
            type="text"
            name="lastName"
            className="form-control"
            placeholder={t("events.form.lastNamePlaceholder")}
            required
            onChange={handleChange}
            autoComplete="family-name"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-company">
            {t("events.form.companyLabel")}
          </label>
          <input
            id="event-form-company"
            type="text"
            name="company"
            className="form-control"
            placeholder={t("events.form.companyPlaceholder")}
            required
            onChange={handleChange}
            autoComplete="organization"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-industry">
            {t("events.form.industryLabel")}
          </label>
          <input
            id="event-form-industry"
            type="text"
            name="industry"
            className="form-control"
            placeholder={t("events.form.industryPlaceholder")}
            required
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-email">
            {t("events.form.emailLabel")}
          </label>
          <input
            id="event-form-email"
            type="email"
            name="email"
            className="form-control"
            placeholder={t("events.form.emailPlaceholder")}
            required
            onChange={handleChange}
            autoComplete="email"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-phone">
            {t("events.form.phoneLabel")}
          </label>
          <input
            id="event-form-phone"
            type="tel"
            name="phone"
            className="form-control"
            placeholder={t("events.form.phonePlaceholder")}
            required
            onChange={handleChange}
            autoComplete="tel"
          />
        </div>

        <div className="col-12">
          <label
            className="form-label"
            htmlFor="event-form-location"
          >
            {t("events.form.locationLabel")}
          </label>
          <select
            id="event-form-location"
            name="location"
            className="form-select"
            required
            onChange={handleChange}
            aria-label={t("events.form.locationAria")}
          >
            <option value="">
              {t("events.form.selectPlaceholder")}
            </option>
            {LOCATION_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="consent"
              id="consentCheck"
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="consentCheck">
              {t("events.form.consent")}
            </label>
          </div>
        </div>

        <div className="col-12">
          <Button className="px-4" type="submit">
            {t("events.form.submit")}
          </Button>
        </div>
      </div>
    </form>
  );
}

Form.displayName = "Form";

export default memo(Form);
